/**
 * Odyssey metadata + config
 */

const bookMetadata = [
  { bookNum: 1, bookTitle: 'Visit of Pallas to Telemachus', stanzas: 11 },
  { bookNum: 2, bookTitle: 'Assembly of the People of Ithaca', stanzas: 11 },
  { bookNum: 3, bookTitle: 'Telemachus Visits Nestor', stanzas: 12 },
  { bookNum: 4, bookTitle: 'Telemachus Visits Menelaus', stanzas: 22 },
  { bookNum: 5, bookTitle: 'Ulysses Leaves Calypso', stanzas: 11 },
  { bookNum: 6, bookTitle: 'Ulysses and Nausicaa', stanzas: 9 },
  { bookNum: 7, bookTitle: 'Ulysses in the Palace of Alcinous', stanzas: 9 },
  { bookNum: 8, bookTitle: 'Ulysses in the Palace of Alcinous (continued)', stanzas: 15 },
  { bookNum: 9, bookTitle: 'Ulysses Tells His Adventures', stanzas: 15 },
  { bookNum: 10, bookTitle: 'Ulysses Tells His Adventures (continued)', stanzas: 15 },
  { bookNum: 11, bookTitle: 'Ulysses Tells His Adventures (continued)', stanzas: 16 },
  { bookNum: 12, bookTitle: 'Ulysses Tells His Adventures (continued)', stanzas: 12 },
  { bookNum: 13, bookTitle: 'Ulysses Returns to Ithaca', stanzas: 11 },
  { bookNum: 14, bookTitle: 'Ulysses in the Hut of Eumaeus', stanzas: 14 },
  { bookNum: 15, bookTitle: 'Ulysses in the Hut of Eumaeus (continued)', stanzas: 14 },
  { bookNum: 16, bookTitle: 'Ulysses Reveals Himself to Telemachus', stanzas: 12 },
  { bookNum: 17, bookTitle: 'Ulysses Goes to the Palace', stanzas: 16 },
  { bookNum: 18, bookTitle: 'Ulysses in the Palace (continued)', stanzas: 11 },
  { bookNum: 19, bookTitle: 'Ulysses and Penelope', stanzas: 15 },
  { bookNum: 20, bookTitle: 'Ulysses and Penelope (continued)', stanzas: 10 },
  { bookNum: 21, bookTitle: 'The Contest of the Bow', stanzas: 11 },
  { bookNum: 22, bookTitle: 'The Slaughter of the Suitors', stanzas: 12 },
  { bookNum: 23, bookTitle: 'Ulysses and Penelope', stanzas: 10 },
];

const BOOKS_WITH_ASSESSMENTS = new Set([1, 2, 5, 9, 11, 12]);

export const chapters = bookMetadata.map((book, index) => ({
  chapter_id: book.bookNum,
  chapt_num: book.bookNum,
  chapt_name: `Book ${book.bookNum}: ${book.bookTitle}`,
  subtitle: `Stanzas 1 - ${book.stanzas}`,
  hasAssessment: BOOKS_WITH_ASSESSMENTS.has(book.bookNum),
  chunk: `chunk${String(index).padStart(2, '0')}`
}));

const getChapterByChunk = (chunk) => chapters.find((ch) => ch.chunk === chunk);

export const config = {
  id: 'Odyssey',
  displayName: 'The Odyssey',
  author: 'Homer',
  coverImage: 'Odyssey.png',
  route: 'Odyssey',
  type: 'epic',
  contentKey: 'Odyssey',
  bookId: 'odyssey',
  usesExternalLinks: false,
  features: {
    hints: false
  },

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    return chapter?.chapt_name || 'The Odyssey';
  },

  getSubtitle: function(fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    return chapter?.subtitle || 'The Odyssey';
  }
};

const book = { config, chapters };

export default book;
